import React, { useEffect } from 'react';
import { Row, Col, CardBody, Card, Alert,Container } from "reactstrap";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// action
import { registerUser } from "../../store/actions";

// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// import images
import profileImg from "../../assets/images/profile-img.png";
import logo from "../../assets/images/icon.svg";
import toastr from "toastr";

const Register = (props) => {

    // handleValidSubmit
  function handleValidSubmit(event, values) {
    event.persist();
    if(!/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(values.email)) {
      toastr.error("Please input correct email address", "Warning");
      return false;
    }
    if(values.password !== values.password_confirmation) {
      toastr.warning("Please confirm your password again", "Warning");
      return false;
    }

    if(values.password.length < 6) {
      toastr.warning("Minimum length of password is 6", "Warning");
      return false;
    }
    props.registerUser(values);
  }

   // useEffect(() => {
   //      if(props.error) {
   //        toastr.error(props.message, "Error")
   //      } else {
   //        toastr.success(props.message, "Success")
   //      }
   // }, [props.message]);

    return (
         <React.Fragment>
        <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="fas fa-home h2"></i>
          </Link>
        </div>
        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-soft-primary">
                    <Row>
                      <Col className="col-7">
                        <div className="text-primary p-4">
                          <h5 className="text-primary">Register</h5>
                          {/*<p>Get your free Skote account now.</p>*/}
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img src={profileImg} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div className="p-2">
                      <AvForm
                        className="form-horizontal"
                        onValidSubmit={(e,v) => {handleValidSubmit(e,v)}}
                      >
                        {/*{props.user && props.user ? (*/}
                        {/*  <Alert color="success">*/}
                        {/*    Register User Successfully*/}
                        {/*  </Alert>*/}
                        {/*) : null}*/}
                        {/*{props.registrationError &&*/}
                        {/*  props.registrationError ? (*/}
                        {/*    <Alert color="danger">*/}
                        {/*      {props.registrationError}*/}
                        {/*    </Alert>*/}
                        {/*  ) : null}*/}

                        <div className="form-group">
                          <AvField
                            name="email"
                            label="Email"
                            className="form-control"
                            placeholder="Enter email"
                            type="email"
                            required
                          />
                        </div>

                        <div className="form-group">
                          <AvField
                              name="name"
                              label="Username"
                              type="text"
                              required
                              placeholder="Enter username"
                          />
                        </div>

                        <div className="form-group">
                          <AvField
                            name="password"
                            label="Password"
                            type="password"
                            required
                            placeholder="Enter Password"
                          />
                        </div>

                        <div className="form-group">
                          <AvField
                              name="password_confirmation"
                              label="Confirm Password"
                              type="password"
                              required
                              placeholder="Retype your password"
                          />
                        </div>

                        <div className="mt-4">
                            <button
                              className="btn btn-primary btn-block waves-effect waves-light"
                              type="submit"
                              disabled={props.loading}
                            >
                              {!props.loading ? "Register" :
                                  <React.Fragment>
                                    <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
                                    Registering
                                  </React.Fragment>
                              }
                            </button>
                        </div>
                      </AvForm>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p>
                    Already have an account ?{" "}
                    <Link
                      to="/login"
                      className="font-weight-medium text-primary"
                    >
                      {""}
                      Login
                    </Link>{" "}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
      );
    }
    
const mapStateToProps = state => {
  const { message, loading, error } = state.RegisterReducer;
  return { message, loading };
};

export default connect(mapStateToProps,{registerUser})(Register);
